import React, { useEffect } from "react";
import { Box, Grid, Typography } from "@mui/material";
import Icon from "../Elements/Icon/Icon";
import Images from "../../constant/images";
import "./Footer.css";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";

const Footer = () => {
  const { t } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const navLinks = [
    { name: t("navigation.home"), path: "/" },
    { name: t("navigation.aboutUs"), path: "/about" },
    { name: t("navigation.service"), path: "/service" },
    { name: t("navigation.Applicant"), path: "/applicant" },
    { name: t("navigation.Employer"), path: "/employer" },
    { name: t("navigation.contactUs"), path: "/contact" },
    { name: t("navigation.HRSolution"), path: "/hr-solution" },
  ];

  const Services = [
    // { item: t("footer.Support") },

    { name: t("footer.Support"), path: "/contact" },

    { name: t("footer.TermsConditions"), path: "/" },
    { name: t("footer.PrivacyPolicy"), path: "/" },
  ];

  return (
    <Box>
      <Box className="desktop-footer">
        <Box
          sx={{
            background: "#20201D",
            color: "white",
            py: 4,
            px: 2,
            textAlign: "center",
            borderTop: "1px solid #741374",
          }}
        >
          <Grid container spacing={4} justifyContent="center">
            {/* Logo Section */}
            <Grid item md={3}>
              <Icon src={Images.logomain} alt="" className="logo-footer" />
            </Grid>

            {/* Menu Section */}
            <Grid item md={2}>
              <Typography variant="h6" gutterBottom className="footer-heading">
                {t("footer.Menu")}
              </Typography>
              <Box>
                {navLinks.map((link) => (
                  <Link
                    to={link.path}
                    key={link.name}
                    className="footer-menues"
                    style={{
                      display: "block",
                      color: "inherit",
                      textDecoration: "none",
                    }}
                  >
                    {link.name}
                  </Link>
                ))}
              </Box>
            </Grid>

            {/* Services Section */}
            <Grid item md={3}>
              <Typography variant="h6" gutterBottom className="footer-heading">
                {t("footer.service")}
              </Typography>
              <Box>
                {/* {Services.map((item, index) => (
                  <Link
                  to={link.path}
                  key={index}
                    className="footer-menues"
                    style={{
                      display: "block",
                      color: "inherit",
                      textDecoration: "none",
                    }}
                  >
                    {item.item}
                  </Link>
                ))} */}

                {Services.map((link) => (
                  <Link
                    to={link.path}
                    key={link.name}
                    className="footer-menues"
                    style={{
                      display: "block",
                      color: "inherit",
                      textDecoration: "none",
                    }}
                  >
                    {link.name}
                  </Link>
                ))}
              </Box>
            </Grid>

            {/* Address Section */}
            <Grid item md={4}>
              <Typography variant="h6" gutterBottom className="footer-heading">
                {t("footer.Address")}
              </Typography>
              <Typography variant="body2" className="footer-menues2">
                {t("footer.HeadquartersOffice")}
                <br />
                <span dir="ltr">{t("footer.OfficeNo")} :</span> +973 77022200
                <br />
                +97339905077
                <br />
                +97333635866
                <br />
                {"Mobile No : "}
                +973 39 905077 <br />
                +973 33 635233
                <br />
                {t("footer.Email")} :{" "}
                <Link
                  to="mailto:info@almaalybh.com"
                  style={{ textDecoration: "none" }}
                  className="footer-menues"
                >
                  info@almaalybh.com{" "}
                </Link>
                <br />
                {t("footer.Instagram")} :{" "}
                <Link
                  to="https://instagram.com/almaaly_manpower"
                  style={{ textDecoration: "none" }}
                  target="_blank"
                  className="footer-menues"
                >
                  @almaaly_manpower
                </Link>
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Box>

      {/* mobile */}
      <Box
        className="monile-footer"
        sx={{ backgroundColor: "#222", color: "white", p: 3 }}
      >
        <Box flex={1} mt={-6}>
          {/* <Icon src={Images.foterlogo} alt="" className="logo-footer-mobile"  /> */}
          <Icon src={Images.logomain} alt="" className="logo-footer-mobile" />
        </Box>
        <Box
          display="flex"
          // textAlign={{ xs: "center", md: "left" }}
          gap={3}
        >
          {/* Logo Section */}

          {/* Menu Section */}
          <Box flex={1}>
            <Typography variant="h6" fontWeight="bold">
              Menu
            </Typography>
            <Typography>Home</Typography>
            <Typography>About Us</Typography>
            <Typography>Services</Typography>
            <Typography>Applicant</Typography>
            <Typography>Employer</Typography>
            <Typography>Contact Us</Typography>
            <Typography>HR Solution</Typography>
          </Box>

          {/* Services Section */}
          <Box flex={1}>
            <Typography variant="h6" fontWeight="bold">
              Services
            </Typography>
            <Typography>Support</Typography>
            <Typography>Terms and Conditions</Typography>
            <Typography>Privacy Policy</Typography>
          </Box>

          {/* Address Section */}
          <Box flex={1}>
            <Typography variant="h6" fontWeight="bold">
              Address:
            </Typography>
            <Typography>Headquarters Office: Bahrain</Typography>
            <Typography>Office No: +973 770 222 00</Typography>
            <Typography>
              Mobile No: +973 39 905077 <br />
              +973 33 635233
            </Typography>
            <Typography>Email: info@almaalybh.com</Typography>
            <Typography>Instagram: @almaaly_manpowe</Typography>
          </Box>
        </Box>

        {/* Footer Text */}
      </Box>
      <Box
        textAlign="center"
        bgcolor="#222"
        borderTop="1px solid gray"
        color={"white"}
        py={2}
      >
        <Typography>
          Copyright 2025 - AI Maaly Requirement & Manpower Services
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
